/* eslint-disable sort-keys */
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

/** Matches vendors/pwa-retail-app/app/theme/components/base/tooltip.js */
const helpers = createMultiStyleConfigHelpers(['root', 'arrow']);

const TOOLTIP_BG = 'blue.800';
const ARROW_SIZE = '8px';

export default helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      bg: TOOLTIP_BG,
      borderRadius: 'base',
      color: 'whiteAlpha.900',
      fontSize: 'sm',
      lineHeight: '1.5em',
      margin: 0,
      maxW: '280px',
      position: 'fixed',
      px: 2,
      py: 2,
      width: 'max-content',
      zIndex: 'tooltip',
    },
    arrow: {
      bg: TOOLTIP_BG,
      bottom: `calc(${ARROW_SIZE} / -2)`,
      height: ARROW_SIZE,
      marginLeft: `calc(${ARROW_SIZE} / -2)`,
      position: 'absolute',
      transform: 'rotate(45deg)',
      width: ARROW_SIZE,
    },
  },
  defaultProps: {
    variant: 'default',
  },
  variants: {
    default: {
      root: {
        pointerEvents: 'none',
      },
    },
    interactive: {
      root: {
        overscrollBehavior: 'contain',
        pointerEvents: 'auto',
        touchAction: 'manipulation',
        userSelect: 'text',
      },
    },
  },
});
